import React from 'react';
import { Box, Typography } from '@mui/material';
import { API_ROOT } from '../services/apiClient';

export function PlayerHeader({ appName = 'Digital Escape Room', quizTitle, logoUrl, showLogo = true }) {
  const resolvedQuizTitle = quizTitle || appName;

  return (
    <Box sx={{ textAlign: 'center' }}>
      {showLogo && logoUrl && (
        <Box
          component="img"
          src={`${API_ROOT}${logoUrl}`}
          alt="Logo kviza"
          sx={{
            display: 'block',
            mx: 'auto',
            mb: 2,
            maxWidth: { xs: 180, sm: 240 },
            maxHeight: { xs: 90, sm: 120 },
            objectFit: 'contain'
          }}
        />
      )}
      <Typography variant="overline" sx={{ letterSpacing: 1.1, color: 'text.secondary' }}>
        {appName}
      </Typography>
      <Typography variant="h4">{resolvedQuizTitle}</Typography>
    </Box>
  );
}
